<template>
	<div class="filters-box-row">
		<div class="filters-container">
			<div class="input-box">
				<span>商品名称：</span>
				<el-input
					v-model="goodsName"
					placeholder="请输入商品名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
				></el-input>
			</div>
			<div class="input-box">
				<span>启用状态：</span>
				<el-select v-model="stackflag" class="name-input" size='mini'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="0" label="启用"></el-option>
					<el-option :value="1" label="停用"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>可售状态：</span>
				<el-select v-model="salestate" class="name-input" size='mini'>
					<el-option :value="-1" label="全部"></el-option>
					<el-option :value="1" label="停售"></el-option>
					<el-option :value="0" label="可售"></el-option>
				</el-select>
			</div>
			<el-button
				type="primary"
				class="btn fx-btn"
				size="small"
				@click="onSearch">查询</el-button>
			<el-button
				class="btn fx-btn"
				size="small"
				plain
				@click="clearing">清空</el-button>
			<el-button size="small" type="text" class="btn" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
			</el-button>
		</div>
		<div class="filters-container" v-if="!collapse">
			<div class="input-box">
				<span>店铺级大类：</span>
				<el-select v-model="bcId" class="select-box" size='small' @change="bcChange">
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in bc">
						<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id" :disabled="item.disabledflag"/>
					</template>
				</el-select>
			</div>
			<div class="input-box" v-if="bigcategoryview === 1">
				<span>店铺级小类：</span>
				<el-select v-model="scId" class="select-box" size='small'>
					<el-option value="0" label="全部"></el-option>
					<template v-for="(item) in sc">
						<el-option :value="item.id" :label="item.name" :key="item.id" :disabled="item.disabledflag"></el-option>
					</template>
				</el-select>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Search',
	props: {
	},
	data () {
		return {
			goodsName: '',
			stackflag: -1,
			salestate: -1,
			collapse: false,
			bcId: '0',
			scId: '0',
			bc: [],
			sc: [],
			bigcategoryview: 0
		}
	},
	created () {
		this.getBigCategory()
		this.checkSmallCategory().then(res => {
			this.bigcategoryview = res.bigcategoryview
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		})
	},
	methods: {
		// 是否开启小类
		checkSmallCategory () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
				}).then(res => {
					resolve(res)
				})
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				pid: this.bcId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		bcChange (value) {
			this.scId = '0'
			this.bcId = '' + value
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		},
		clearing () {
			this.goodsName = ''
			this.stackflag = -1
			this.salestate = -1
			this.bcId = '0'
			this.scId = '0'
			if (this.bigcategoryview === 1) {
				this.getSmalCategory()
			}
		},
		onSearch () {
			let params = {
				goodsName: this.goodsName,
				stackflag: this.stackflag,
				salestate: this.salestate,
				bcId: this.bcId,
				scId: this.scId
			}
			this.$emit('handleSearch', params)
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	flex-direction column
	width :100%;
	line-height :60px;
	min-width :600px;
	box-sizing: border-box
	.filters-container {
		display flex
		flex: 1
		height: 60px
		.input-box {
			display flex
			width: 240px
			margin-left: 20px
			span {
				margin-right: 10px
			}
			.name-input {
				flex: 1
			}
		}
		.time-box{
			width :300px
			span {
				margin-right: 10px
			}
			.time-picker{
				width 210px;
			}
		}
		.select-box{
			width : 158px
			.select-input{
				width :120px;
				margin-right :10px;
			}
			.name-input{
				width :150px
			}
		}
		.btn {
			height: 32px
			margin-top: 14px
			margin-left 20px
		}
	}
}
</style>
